import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cspz",
  "use": "icon-cspz-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cspz\"><path d=\"M256 128h768v64H256zM0 512h768v64H0zM256 896h768v64H256zM0 64h192V256H0V64zM64 128v64H128V128H64zM832 448H1024V640H832V448zM896 512v64h64V512H896zM0 832h192V1024H0V832z m64 64v64H128V896H64z\" p-id=\"5902\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol